(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.unknown = mod.exports;
  }
})(this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.value2moment = _exports.moment2value = void 0;

  var moment2value = function moment2value(value, format) {
    if (value && value._isAMomentObject) {
      return value.format(format);
    } else {
      return null;
    }
  };

  _exports.moment2value = moment2value;

  var value2moment = function value2moment(moment, value, format) {
    if ([null, undefined].indexOf(value) !== -1) {
      return undefined;
    } else if (value && !value._isAMomentObject) {
      return moment(value, format, true);
    } else {
      return value;
    }
  };

  _exports.value2moment = value2moment;
});